import { useIntl } from "react-intl";
import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import styles from "./Logo.module.css";
import { clsx } from "clsx";

export default function Logo({ className }: { className?: string }) {
  const intl = useIntl();
  const brand = useBrandLoaderData();

  return (
    <img
      src={brand.logo}
      alt={intl.formatMessage(
        { defaultMessage: "{brand} Logo" },
        { brand: brand.name }
      )}
      className={clsx(styles.logo, className)}
    />
  );
}
